import React from "react";

import { formatRupiah } from "../../../helper/formatNumber";
import "./salesSummaryYearly.css";

const SalesSummaryYearly = ({ summaryData }) => {
  console.log(summaryData);
  return (
    <div className="sales-summary-yearly-container">
      <div className="sales-summary-yearly-row">
        <h2 className="sales-summary-yearly-column-title-transaction">
          Total Penjualan:
        </h2>
        <h3 className="sales-summary-yearly-column">
          <b>{formatRupiah(summaryData.total_transaction_yearly)}</b>
        </h3>
      </div>
    </div>
  );
};

export default SalesSummaryYearly;
